export default __webpack_public_path__ + "static/media/6 - Charcoal Portrait.e55db83a.jpeg";